<template>
<!-- eslint-disable -->
  <v-app>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6" lg="4">
            <v-card class="elevation-12" style="background-color: #363636">
              <div class="px-3 pt-3">
                <v-img contain :src="require('@/assets/logo2.png')" transition="scale-transition" />
              </div>
              <v-card-text>
                <v-form v-if="!enrichment" v-model="valid" ref="form">
                  <v-text-field
                    label="Introduzca su número de telefono para iniciar sesión"
                    :rules="[rules.required, rules.max(256)]"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="msisdn"
                  />
                </v-form>
                <v-row v-else justify="center" align="center">
                  <v-progress-circular
                    size="100"
                    indeterminate
                    color="viralYellow"
                  />
                </v-row>
              </v-card-text>
              <v-card-actions v-if="!enrichment">
                <v-spacer />
                <v-btn dark color="viralYellow primary--text" :disabled="msisdn == '' || waiting" :loading="waiting" @click="mLogin()">
                  Iniciar sesión
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import rulesMixin from '@/mixins/rules'
export default {
  mixins: [rulesMixin],
  data() {
    return {
      valid: false,
      msisdn: '',
      enrichment: false,
      waiting: false
    }
  },
  async mounted() {
    window.scrollTo(0, 0)

    // 1. Verificar si el usuario ya tiene acceso VIP (por URL o por LocalStorage)
    const isVip = this.$route.query.access === 'vip' || localStorage.getItem('access') === 'vip'

    if (isVip) {
      // Si entró por URL con ?access=vip, nos aseguramos de guardarlo
      if (this.$route.query.access === 'vip') {
        localStorage.setItem('access', 'vip')

        // 2. Redirigir al usuario a su destino original o a la Home
        const pendingRoute = localStorage.getItem('redirectAfterLogin')

        if (pendingRoute) {
          const dest = JSON.parse(pendingRoute)
          localStorage.removeItem('redirectAfterLogin') // Limpiamos la basura
          this.$router.push(dest)
        } else {
          this.$router.push({ name: 'home' })
        }
        return
      }

      // 3. Si no es VIP, simplemente preparamos la vista de login manual
      this.enrichment = false
      this.waiting = false
    }
  },
  methods: {
    ...mapActions({
      login: 'login/login',
      loginApn: 'login/loginApn',
      loadAllData: 'viralmobile/getData',
      addAlert: 'alerts/add'
    }),
    async mLogin() {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({ text: 'Por favor, compruebe los campos en rojo', color: 'error' })
        return
      }
      try {
        this.waiting = true
        await this.login({
          msisdn: this.msisdn,
          access: localStorage.getItem('access')
        })
        this.loadAllData()
        this.redirectAfterLogin()
      } catch (e) {
        this.addAlert({ text: e.response.data, color: 'error' })
      } finally {
        this.waiting = false
      }
    },
    async mLoginApn(params) {
      try {
        this.waiting = true
        await this.loginApn({
          token: params.token ? params.token : null,
          operator: params.operator ? params.operator : null,
          access: localStorage.getItem('access')
        })
        this.loadAllData()
        this.redirectAfterLogin()
      } catch (e) {
        this.enrichment = false
        this.waiting = false
      }
    },
    redirectAfterLogin() {
      const redirectRoute = localStorage.getItem('redirectAfterLogin')
      if (redirectRoute != null) {
        try {
          this.$router.push(JSON.parse(redirectRoute))
        } catch (e) {
          this.$router.push({ name: 'home' })
        }
      } else {
        this.$router.push({ name: 'home' })
      }
      localStorage.setItem('login', localStorage.getItem('access'))
      localStorage.removeItem('redirectAfterLogin')
      this.waiting = false
    }
  }
}
</script>
